import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "terms-modal__panel" }
const _hoisted_3 = { class: "terms-modal__head" }
const _hoisted_4 = { class: "terms-modal__meta" }
const _hoisted_5 = ["id"]
const _hoisted_6 = {
  key: 0,
  class: "terms-modal__date"
}
const _hoisted_7 = { class: "terms-modal__body" }
const _hoisted_8 = {
  key: 0,
  class: "terms-modal__sections"
}
const _hoisted_9 = { class: "terms-modal__section-title" }
const _hoisted_10 = { class: "terms-modal__section-body" }
const _hoisted_11 = {
  key: 1,
  class: "terms-modal__table-wrap"
}
const _hoisted_12 = { class: "terms-modal__table" }

import { computed, onUnmounted, watch } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { COMPANY } from '@/constants/legalContent'
import type { PrivacyCollectionRow } from '@/constants/legalContent'


export default /*@__PURE__*/_defineComponent({
  __name: 'TermsModal',
  props: {
    open: { type: Boolean },
    title: {},
    updatedAt: {},
    sections: {},
    privacyRows: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const titleId = computed(() => `terms-modal-title-${props.title.replace(/\s/g, '-')}`)

const close = () => emit('close')

const onKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape' && props.open) close()
}

watch(
  () => props.open,
  (isOpen) => {
    document.body.style.overflow = isOpen ? 'hidden' : ''
  },
)

onUnmounted(() => {
  document.body.style.overflow = ''
  window.removeEventListener('keydown', onKeydown)
})

watch(
  () => props.open,
  (isOpen) => {
    if (isOpen) {
      window.addEventListener('keydown', onKeydown)
    } else {
      window.removeEventListener('keydown', onKeydown)
    }
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "terms-modal" }, {
      default: _withCtx(() => [
        (__props.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "terms-modal",
              role: "dialog",
              "aria-modal": "true",
              "aria-labelledby": titleId.value,
              onClick: _withModifiers(close, ["self"])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("header", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(COMPANY).serviceName), 1),
                    _createElementVNode("h2", {
                      id: titleId.value,
                      class: "terms-modal__title"
                    }, _toDisplayString(__props.title), 9, _hoisted_5),
                    (__props.updatedAt)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, "시행일 " + _toDisplayString(__props.updatedAt), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "terms-modal__close",
                    "aria-label": "닫기",
                    onClick: close
                  }, [
                    _createVNode(AppIcon, {
                      icon: "mdi-close",
                      size: 22
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "default"),
                  (__props.sections?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sections, (section) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: section.title,
                            class: "terms-modal__section"
                          }, [
                            _createElementVNode("h3", _hoisted_9, _toDisplayString(section.title), 1),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(section.body), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (__props.privacyRows?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("table", _hoisted_12, [
                          _cache[0] || (_cache[0] = _createElementVNode("caption", { class: "terms-modal__table-caption" }, "개인정보 수집 항목", -1)),
                          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { scope: "col" }, "구분"),
                              _createElementVNode("th", { scope: "col" }, "수집 항목"),
                              _createElementVNode("th", { scope: "col" }, "수집 목적"),
                              _createElementVNode("th", { scope: "col" }, "보유 기간")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.privacyRows, (row) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: row.category
                              }, [
                                _createElementVNode("td", null, _toDisplayString(row.category), 1),
                                _createElementVNode("td", null, _toDisplayString(row.items), 1),
                                _createElementVNode("td", null, _toDisplayString(row.purpose), 1),
                                _createElementVNode("td", null, _toDisplayString(row.retention), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("footer", { class: "terms-modal__foot" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-primary terms-modal__confirm",
                    onClick: close
                  }, "확인")
                ])
              ])
            ], 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})